import { render, staticRenderFns } from "./createXiangmu.vue?vue&type=template&id=321c1ba1&scoped=true"
import script from "./createXiangmu.vue?vue&type=script&lang=js"
export * from "./createXiangmu.vue?vue&type=script&lang=js"
import style0 from "./createXiangmu.vue?vue&type=style&index=0&id=321c1ba1&prod&scoped=true&lang=css"
import style1 from "./createXiangmu.vue?vue&type=style&index=1&id=321c1ba1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c1ba1",
  null
  
)

export default component.exports